
import { ECarShopField } from '@/common/enum/carShop';
import { ICarShopField } from '@/common/interface/carSpu';
import AddressField from '@/components/shop/fields/AddressField.vue';
import AreaField from '@/components/shop/fields/AreaField.vue';
// import BOrderField from '@/components/shop/fields/BOrderField.vue';
import BossIdImagesField from '@/components/shop/fields/BossIdImagesField.vue';
// import ManagerTelsField from '@/components/shop/fields/ManagerTelsField.vue';
// import BossTelsField from '@/components/shop/fields/BossTelsField.vue';
// import BusinessTimeField from '@/components/shop/fields/BusinessTimeField.vue';
import CommonField from '@/components/shop/fields/CommonField.vue';
// import DataChedField from '@/components/shop/fields/DataChedField.vue';
// import LatitudeField from '@/components/shop/fields/LatitudeField.vue';
// import LongitudeField from '@/components/shop/fields/LongitudeField.vue';
// import MainBusinessField from '@/components/shop/fields/MainBusinessField.vue';
import MapLocationField from '@/components/shop/fields/MapLocationField.vue';
// import MechineCallbackDataField from '@/components/shop/fields/MechineCallbackDataField.vue';
import NameField from '@/components/shop/fields/NameField.vue';
// import ParkNumField from '@/components/shop/fields/ParkNumField.vue';
// import PayeeAccountFreezeStatusField from '@/components/shop/fields/PayeeAccountFreezeStatusField.vue';
import PoiField from '@/components/shop/fields/PoiField.vue';
// import RegionField from '@/components/shop/fields/RegionField.vue';
// import RestAreaField from '@/components/shop/fields/RestAreaField.vue';
// import ShopIdField from '@/components/shop/fields/ShopIdField.vue';
import ShopLicenseField from '@/components/shop/fields/ShopLicenseField.vue';
// import ShopServiceField from '@/components/shop/fields/ShopServiceField.vue';
// import StartTimeField from '@/components/shop/fields/StartTimeField.vue';
// import StationField from '@/components/shop/fields/StationField.vue';
import TelsField from '@/components/shop/fields/TelsField.vue';
import VideosField from '@/components/shop/fields/VideosField.vue';
import CertificateAddressDistanceField from '@/components/shop/fields/CertificateAddressDistanceField.vue';
// import AlbumImageField from '@/components/shop/fields/AlbumImageField.vue';
import ShopImagesAlbumField from '@/components/shop/fields/ShopImagesAlbumField.vue';
import AlbumImageField from '@/components/shop/fields/AlbumImageField.vue';

import _ from 'lodash';

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
// import ShopImagesField from '@/components/shop/fields/ShopImagesField.vue';

@Component({})
export default class ShopAudit extends Vue {
  toAuditForm: { [key: string]: any } = {};

  toAuditFormItems: ICarShopField[] = [];

  rawForm: { [key: string]: any } | null = null;

  initShopFields: ICarShopField[] = [
    {
      label: ECarShopField.NAME,
      labelName: '店铺名称',
    },
    {
      label: ECarShopField.POI,
      labelName: 'POIID',
      readonly: true,
    },

    {
      label: ECarShopField.START_TIME,
      labelName: '开业时间',
    },
    {
      label: ECarShopField.BUSINESS_TIME,
      labelName: '营业时间',
    },
    {
      label: ECarShopField.MAIN_BUSINESS_ATAG_NAME,
      labelName: '主营业务',
    },
    {
      label: ECarShopField.AREA,
      labelName: '营业面积',
    },
    {
      label: ECarShopField.MERCHANT_TELEPHONE,
      labelName: '商家电话',
    },
    // {
    //   label: ECarShopField.VIDEOS,
    //   labelName: '实拍视频(审核)',
    // },
    {
      label: ECarShopField.CAR_SHOP_CODE,
      labelName: '门店编码',
    },
    {
      label: ECarShopField.ADDRESS,
      labelName: '地址明细',
    },
    {
      label: ECarShopField.HEAD_PICS,
      labelName: '店铺头图',
    },
    {
      label: ECarShopField.COVER_PICS,
      labelName: '店铺封面图',
    },
    {
      label: ECarShopField.PICS,
      labelName: '店铺图片',
    },
    {
      label: ECarShopField.JOIN_VIDEOS,
      labelName: '入驻门店视频',
    },
    {
      label: ECarShopField.TELS,
      labelName: '联系电话',
    },
    {
      label: ECarShopField.MANAGER_ID,
      labelName: '联系人身份证',
    },
    {
      label: ECarShopField.IDENTITY_NUM,
      labelName: '联系人身份证号码',
    },
    {
      label: ECarShopField.SHOP_LICENSE,
      labelName: '店铺营业执照',
    },
    {
      label: ECarShopField.CERTIFICATE_ADDRESS_DISTANCE,
      labelName: '营业执照地址&门店实际地址',
    },
    {
      label: ECarShopField.OTHER_QUALIFICATIONS,
      labelName: '其他补充资质',
    },
    {
      label: ECarShopField.ONLINE_STATUS,
      labelName: '门店状态',
    },
    {
      label: ECarShopField.CP_ID,
      labelName: '门店类型',
    },
    {
      label: ECarShopField.VIDEOS,
      labelName: '视频',
    },
    {
      label: ECarShopField.MAPLOCATION,
      labelName: '地图位置',
    },

  ];

  @Prop({
    default: {},
  })
  readonly auditUpdateData!: { [key: string]: any };

  @Prop()
  readonly rawData!: { [key: string]: any };

  @Prop()
  tplType!: string;

  @Watch('auditUpdateData', { deep: true })
  watchAuditUpdateData() {
    // console.log(this.auditUpdateData);
    if (!this.auditUpdateData) {
      this.toAuditForm = {};
      return;
    }

    this.toAuditForm = _.cloneDeep(this.auditUpdateData);
    this.toAuditFormItems = this.initShopConfig(this.toAuditForm);
  }

  @Watch('rawData')
  watchRawData() {
    if (!this.rawData) {
      this.rawForm = null;
      return;
    }

    this.rawForm = _.cloneDeep(this.rawData);
  }

  getComponent(type: ECarShopField) {
    switch (type) {
      case ECarShopField.ADDRESS: {
        return AddressField;
      }
      case ECarShopField.AREA: {
        return AreaField;
      }
      case ECarShopField.BOSS_ID: {
        return BossIdImagesField;
      }

      case ECarShopField.NAME: {
        return NameField;
      }

      case ECarShopField.POI: {
        return PoiField;
      }
      case ECarShopField.PICS: {
        return ShopLicenseField;
      }

      case ECarShopField.TELS: {
        return TelsField;
      }
      case ECarShopField.MAPLOCATION: {
        return MapLocationField;
      }

      case ECarShopField.MANAGER_ID: {
        return BossIdImagesField;
      }

      case ECarShopField.HEAD_PICS: {
        return ShopLicenseField;
      }

      case ECarShopField.COVER_PICS: {
        return ShopLicenseField;
      }

      case ECarShopField.SHOP_LICENSE: {
        return ShopLicenseField;
      }

      case ECarShopField.JOIN_VIDEOS: {
        return VideosField;
      }

      case ECarShopField.VIDEOS: {
        return VideosField;
      }
      case ECarShopField.OTHER_QUALIFICATIONS: {
        return ShopLicenseField;
      }
      case ECarShopField.CERTIFICATE_ADDRESS_DISTANCE: {
        return CertificateAddressDistanceField;
      }

      case ECarShopField.ALBUM_IMAGES: {
        return AlbumImageField;
      }


      case ECarShopField.ALBUM_ADD_IMAGES: {
        return ShopImagesAlbumField;
      }

      default: {
        return CommonField;
      }
    }
  }

  initShopConfig(shopForm: { [key: string]: any }) {
    // console.log(shopForm);

    const form = _.cloneDeep(shopForm);
    const keys = Object.keys(form);
    const shopFields = _.cloneDeep(this.initShopFields);
    const shopKernel = shopFields.filter((item: ICarShopField) => {
      return keys.indexOf(item.label) > -1;
    });
    const detail: ICarShopField[] = [...shopKernel];
    console.log(detail);
    return this.replaceImageFields(detail);
  }

  getToAuditData() {
    const toAuditData = _.cloneDeep(this.auditUpdateData);
    if (typeof toAuditData.mapLocation !== 'undefined') {
      delete toAuditData.mapLocation;
    }
    if (typeof toAuditData.bOrder !== 'undefined') {
      delete toAuditData.bOrder;
    }
    return toAuditData;
  }

  replaceImageFields(data: ICarShopField[]) {
    if (!this.toAuditForm.is_album) {
      return data;
    }
    const labelsToRemove = new Set([
      ECarShopField.HEAD_PICS,
      ECarShopField.COVER_PICS,
      ECarShopField.PICS,
    ]);
    console.log(this.toAuditForm, 'toAuditForm');
    const newAlbumField: ICarShopField = {
      label: ECarShopField.ALBUM_IMAGES,
      labelName: '店铺图片',
    };
    if (this.tplType === 'car-shop') {
      newAlbumField.label = ECarShopField.ALBUM_ADD_IMAGES;
    } else if (this.tplType === 'car-shop-edir') {
      newAlbumField.label = ECarShopField.ALBUM_IMAGES;
    }
    const initShopFields = [
      ...data.filter((field) => !labelsToRemove.has(field.label)),
      newAlbumField,
    ];
    console.log(initShopFields, 'initShopFields');
    return initShopFields;
  }

  mounted() {
    this.watchAuditUpdateData();
    this.watchRawData();
  }
}
